import { motion } from "framer-motion";
import { MessagesSquare } from "lucide-react";
import { useLang } from "@/lib/i18n";

const WA_URL =
  "https://wa.me/+2349068043369?text=" +
  encodeURIComponent("Hello Norex, I would like to inquire about your trading services.");

export const WhatsAppFloat = () => {
  const { t } = useLang();
  return (
  <motion.a
    data-testid="whatsapp-float-button"
    href={WA_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with Norex on WhatsApp"
    initial={{ opacity: 0, scale: 0.6, y: 20 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ duration: 0.5, delay: 2, ease: [0.22, 1, 0.36, 1] }}
    className="group fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-gold text-midnight shadow-[0_8px_30px_rgba(212,175,55,0.35)] hover:bg-gold-light transition-[background-color,transform] duration-200 hover:scale-110"
  >
    <span className="absolute inset-0 rounded-full bg-gold animate-pulse-ring" />
    <MessagesSquare className="relative w-6 h-6" />
    <span className="absolute right-full mr-4 whitespace-nowrap bg-surface2 border border-[#1E293B] text-[#F4F6F8] text-xs px-3 py-2 rounded-sm opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-200 pointer-events-none">
      {t.float.tooltip}
    </span>
  </motion.a>
  );
};
